var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.error)?_c('b-toast',{attrs:{"visible":"","title":"Error","variant":"danger","solid":"","no-fade":"","no-auto-hide":""},on:{"change":_vm.clearError}},[(_vm.error)?[_c('strong',[_vm._v(_vm._s(_vm.error.message))]),_c('div',[_vm._v(_vm._s(_vm.error.stack))])]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }